import { useEffect } from 'react'
import { SectionStatus } from './SectionListItem'
import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'

interface Props {
  status: SectionStatus
  isOpen: boolean
}

const getAnimationStatusValue = (status: SectionStatus) =>
  status === 'valid' ? 1 : status === 'invalid' ? -1 : 0

const getAnimationOpenValue = (isOpen: boolean) => (isOpen ? 1 : 0)

export default function ProgressDot({ status, isOpen }: Props) {
  const animateStatus = useSharedValue(getAnimationStatusValue(status))
  const animateOpen = useSharedValue(getAnimationOpenValue(isOpen))

  const styleStatus = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      animateStatus.value,
      [-1, 0, 1],
      [colors.red[600], colors.black, colors.green[600]]
    ),
    opacity: interpolate(
      // 0 when closed + default status, 1 when open or status set to valid or invalid
      1 -
        (1 - animateOpen.value) *
          (1 - Math.min(1, Math.abs(animateStatus.value))),
      [0, 1],
      [0.2, 1]
    ),
    width: interpolate(animateOpen.value, [0, 1], [8, 24]),
  }))

  useEffect(() => {
    animateStatus.set(withTiming(getAnimationStatusValue(status)))
    animateOpen.set(withTiming(getAnimationOpenValue(isOpen)))
  }, [animateStatus, animateOpen, status, isOpen])

  return (
    <Animated.View
      style={[styleStatus, { height: 8, borderRadius: 4 }]}
    ></Animated.View>
  )
}
